const AVAILABLE_SITE_LANGUAGES_COUNTRIES = [
    "en-be",
    "nl-be",
    "fr-be",
    "fr-fr",
    "en-lu",
    "fr-lu",
];

export const DEGROOF_DOMAIN = "www.degroofpetercam.com";

// Function to normalize base URL by removing trailing slashes to prevent double slashes
export const normalizeBaseUrl = (location: any): string => {
    // If location.origin is available (client-side), use it
    if (location && location.origin) {
        return location.origin.endsWith("/")
            ? location.origin.slice(0, -1)
            : location.origin;
    }

    // Fallback to environment variable or default (server-side)
    const baseUrl = process.env.URL || "https://www.dpaminvestments.com";
    const resolvedBaseUrl =
        baseUrl.includes("dpaminvestments.com") && !baseUrl.includes("www.")
            ? baseUrl.replace("dpaminvestments.com", "www.dpaminvestments.com")
            : baseUrl;

    // Remove trailing slash if present to prevent double slashes
    return resolvedBaseUrl.endsWith("/")
        ? resolvedBaseUrl.slice(0, -1)
        : resolvedBaseUrl;
};

export const getFixedUrlIfMarketAndLanguageDoesNotExist = (
    link: string,
    language: string,
    market: string,
) => {
    const key = `${language}-${market}`;
    return AVAILABLE_SITE_LANGUAGES_COUNTRIES.includes(key)
        ? link
        : link.replace(`/${key}/`, "/en-be/");
};

export const overrideDashForWhiteSpace = (text: string): string => {
    return text.replace(/-/g, " ");
};

export const deleteMoreThanOneBlankBetweenWords = (text: string): string => {
    return text.replace(/\s+/g, " ");
};
export const overrideSpecialCharacters = (text: string): string => {
    return text
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[æǽ]/g, "ae")
        .replace(/[œ]/g, "oe")
        .replace(/[ÀÁÂÃÄÅ]/g, "A")
        .replace(/[àáâãäå]/g, "a")
        .replace(/[Ç]/g, "C")
        .replace(/[ç]/g, "c")
        .replace(/[Ð]/g, "D")
        .replace(/[ð]/g, "d")
        .replace(/[ÈÉÊË]/g, "E")
        .replace(/[èéêë]/g, "e")
        .replace(/[ÌÍÎÏ]/g, "I")
        .replace(/[ìíîï]/g, "i")
        .replace(/[Ñ]/g, "N")
        .replace(/[ñ]/g, "n")
        .replace(/[ÒÓÔÕÖØ]/g, "O")
        .replace(/[òóôõöø]/g, "o")
        .replace(/[ÙÚÛÜ]/g, "U")
        .replace(/[ùúûü]/g, "u")
        .replace(/[Ý]/g, "Y")
        .replace(/[ýÿ]/g, "y");
};
